<template>
    <div class="billa-app--popup">
        <div class="billa-app--popup--box">
            <div class="billa-app--popup--box--header">
                <div class="billa-app--popup--box--header--col">
                    Tento krok sa nedá vrátiť, chcete pokračovať?
                </div>

                <div class="billa-app--popup--box--header--col">
                    <span @click="$emit('closePopup')">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" fill="currentColor" />
                        </svg>
                    </span>
                </div>
            </div>

            <div class="billa-app--popup--box--body">
                Zadajte emailovú adresu, ktorú ste použili pri registrácii fotografie do súťaže.
                Tam bude odoslaný odkaz, pomocou ktorého bude možné fotografiu zmazať a odhlásiť sa zo súťaže.
            </div>

            <div v-if="sended" class="billa-app--popup--box--body">
                <strong>Email bol úspešne odoslaný!</strong>
            </div>

            <div v-if="!sending" class="billa-app--popup--box--form">
                <label class="billa-app-label billa-app-label-white">
                    <div class="billa-app-label--title">Email</div>
                    <input type="text" v-model="data.email">
                </label>
            </div>

            <div class="billa-app--popup--box--footer">
                <div v-if="!sending" class="billa-app-button billa-app-button-green" @click="deletePhoto()">
                    Pokračovať
                </div>

                <div v-if="sended" class="billa-app-button billa-app-button-green" @click="$emit('closePopup')">
                    Vrátiť sa na stránku
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
			options: {
				type: Object
			}
		},
        data() {
            return {
                sending: false,
                sended: false,
                data: {
                    email: ""
                }
            }
        },
        methods: {
            deletePhoto() {
                this.sending = true

                axios.post(`${this.options.app_url}/api/resources/out-of-competition`, this.data)
				.then( response => { 

                    if ( !response.data.status ) return alert('Zadaný email sa v našej databáze nenachádza!')

					this.sended = true
				})
				.catch( errors => {
                    this.sending = false
                    return alert( errors.response.data.message )
                })
            }
        },
    }
</script>